/**
 * Feedback telemetry beacon.
 *
 * Fires a best-effort POST to the backend's /api/feedback-events endpoint
 * whenever a user clicks 👍 / 👎 on an assistant message. Errors are
 * swallowed — telemetry must never break the chat flow.
 */

import { getBackendUrl } from '../config/runtimeConfig';
import { getBackendHeaders } from './backendAuth';

export interface FeedbackEventInput {
  messageId: string;
  conversationId?: string | null;
  agentId?: string | null;
  rating: 'up' | 'down';
  comment?: string | null;
  model?: string | null;
}

export async function sendFeedback(event: FeedbackEventInput): Promise<void> {
  try {
    const backendUrl = getBackendUrl();
    if (!backendUrl) return;
    await fetch(`${backendUrl}/feedback-events`, {
      method: 'POST',
      headers: await getBackendHeaders(),
      body: JSON.stringify(event),
      keepalive: true,
    });
  } catch (error: unknown) {
    const message = error instanceof Error ? error.message : 'unknown';
    console.warn('[feedbackTelemetry] Failed to send feedback event:', message);
  }
}
